var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { FETCH_ORDERS_BY_STATUS_REQUEST, fetchOrdersByStatusFailure, fetchOrdersByStatusSuccess, } from "@/redux/actions";
import APIIN from "@/utils/APIIN";
const onFetchGetOrderByStatus = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.get(`/cnvt/shipment/shipment/list`, action.payload)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchGetOrderByStatusWorker(action) {
    try {
        const data = yield call(onFetchGetOrderByStatus, action);
        yield put(fetchOrdersByStatusSuccess(data));
    }
    catch (error) {
        yield put(fetchOrdersByStatusFailure(error));
    }
}
export function* watchGetOrderByStatusData() {
    yield takeLatest(FETCH_ORDERS_BY_STATUS_REQUEST, fetchGetOrderByStatusWorker);
}
